/*
 * Created on Tue Jun 15 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useState, useReducer, useEffect, useRef } from 'react';
import { Link, Route, useRouteMatch, useLocation, Switch } from 'react-router-dom';
import parse from 'html-react-parser';
import { useWindowDimensions } from "../utils/helpers";
import { fakeFirstname, fakeLastname, notifications } from '../temp_database';
import { images, mobileImages, getAccountTypeMeta } from '../constants';
import preloader from "../assets/images/preloaders/03-preloader-6px-000000.gif";

import Logo from "../assets/images/icons/big-pink-logo.png";
import BlackLogo from "../assets/images/icons/black-logo-36.png";
import WhiteLogo from "../assets/images/icons/white-logo-36.png";
import PinkLogo from "../assets/images/icons/pink-logo-36.png";
import BlackLogo27 from "../assets/images/icons/black-logo-27.png";
import WhiteLogo27 from "../assets/images/icons/white-logo-27.png";
import PinkLogo27 from "../assets/images/icons/pink-logo-27.png";
import greyX from "../assets/images/icons/grey-close.png";
import pinkX from "../assets/images/icons/pink-close.png";
import WhiteSearch from "../assets/images/icons/white-search.png";
import GreySearch from "../assets/images/icons/grey-search.png";
import { MenuFooter } from "../Footer";

import { Carousel, Modal } from 'react-bootstrap';
import InfiniteScroll from "react-infinite-scroll-component";
import useModal from '../hooks/modal.hook';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import useGetMyProfile from '../hooks/get-user-profile.hook';
import useGetProfile from 'hooks/get-profile.hook';

import Image from '../components/shared/image';
import Toast from '../components/shared/toast';

import ArtworkGallery from './artwork-gallery';
import useAuth from 'hooks/auth.hook';
import LeftDrawer from 'components/shared/left-drawer/left-drawer';
import TopNav from 'components/shared/top-nav';

import { QueryCache } from '@tanstack/react-query'
import { getName } from 'utils/utils';

export default function Find() {
    const { path } = useRouteMatch();
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname])

    return (
        <>
            {location.state && location.state.from === 'signup' ?
                <SuccessModal modalClass="" greyText="Now, let's get you started." redirect="/home/tour" />
            : null}
            
            <Switch location={location}>
                <Route path={`${path}/tour`}>
                    <Tour />
                </Route>
                <Route path="/home/:accountType?/:subType?">
                    <ArtworkGallery/>
                </Route>
            </Switch>
        </>
    );
}


export function TopNavOld({ addClass }) {
    const { fetching, success, profile } = useGetMyProfile()
    
    const accountTypeMeta = getAccountTypeMeta(profile?.accountType);
    const fallBackAvatar = accountTypeMeta.fallBackAvatar;

    const { setModal } = useModal()
    const { push } = useHistory()
    const { pathname } = useLocation()

    let location = pathname.substring(1);
    const { windowWidth } = useWindowDimensions();
    // set pink background for home and black background for zine
    const isPink = location === '' ? false : true;
    // change logo on mobile
    const blackLogo = windowWidth > 1030 ? BlackLogo : BlackLogo27;
    const whiteLogo = windowWidth > 1030 ? WhiteLogo : WhiteLogo27;
    const pinkLogo = windowWidth > 1030 ? PinkLogo : PinkLogo27;
    const blackBackground = '#2B2A29';
    const pinkBackground = '#EC0F69';
    const whiteText = '#EFEFEF';
    const greyText = '#BDBDBD';
    // set initial state of zine or home
    const [logo, setLogo] = useState(isPink ? blackLogo : pinkLogo);
    const [background, setBackground] = useState(isPink ? pinkBackground : blackBackground);
    const [text, setText] = useState(whiteText);
    const [showPanel, togglePanel] = useState({
        showMenu: false,
        showNoti: false,
        showAvatar: false
    });

    const { showMenu, showNoti, showAvatar } = showPanel;

    const [ avatarMenuActive, setAvatarMenuActive ] = useState(false)

    // initialise logo to make sure black logo appears on home and pink logo appears on zine
    const initialiseLogo = () => {
        setLogo(isPink ? blackLogo : pinkLogo);
    }

    const toggleMenu = (show = false) => {
        togglePanel({
            showMenu: show ? true : !showMenu,
            showNoti: false,
            showAvatar: false
        })
        if (show) {
            setLogo(whiteLogo);
        }
        else {
            initialiseLogo();
        }
    }

    const toggleNoti = () => {
        togglePanel({
            showMenu: false,
            showNoti: !showNoti,
            showAvatar: false
        })
    }

    const toggleAvatar = () => {
        togglePanel({
            showMenu: false,
            showNoti: false,
            showAvatar: !showAvatar
        })
    }

    useEffect(() => {
        if (logo === pinkLogo) {
            setBackground(blackBackground);
            setText(greyText);
        }
        else if (logo === blackLogo) {
            setBackground(pinkBackground);
            setText(whiteText);
        }
        // eslint-disable-next-line
    }, [logo])

    useEffect(() => {
        initialiseLogo();
        // eslint-disable-next-line
    }, [windowWidth])

    useEffect(() => {
        if (showMenu) {
            setLogo(whiteLogo);
        }
        else {
            initialiseLogo();
        }
        // eslint-disable-next-line
    }, [showMenu])

    useEffect(() => {
        setAvatarMenuActive(false)
    }, [pathname])

    return (
        <div id="top-nav" className={"top-nav " + (addClass ? addClass : '')} style={{ background: background }}>
            <div
                className={"logo-div float-left " + (showMenu ? "toggle" : "")}
                onMouseOver={() => windowWidth >= 1030 ? toggleMenu(true) : null}
                onMouseOut={initialiseLogo}
                onClick={() => windowWidth < 1030 ? toggleMenu() : null}
            >
                <img src={logo} alt="logo" />
                <LeftDrawer />
            </div>
            <ul className="tabs nexa-x-bold" style={{ color: text }}>
                <li
                    className="zine-home-toggle"
                    onMouseOver={() => setLogo(isPink ? pinkLogo : blackLogo)}
                    onMouseOut={initialiseLogo}
                >
                    <Link to={isPink ? '/' : '/home'}>
                        {isPink ? 'zine' : 'home'}
                    </Link>
                </li>
                <li className="position-relative" onClick={toggleNoti}>
                    <Link to="#" onClick={(e) => e.preventDefault()}>psst</Link>
                    {windowWidth >= 1030 ? <span className="pn-bold activity-count">{notifications.length}</span> : null}
                    {isPink && logo === blackLogo ? <div className={"small-triangle " + (showNoti ? 'show' : '')}></div> : null}
                    <Notification show={showNoti} />
                </li>
                <li className="position-relative">
                    {location !== 'search' ?
                        <Link to="/search">search</Link>
                        :
                        <>
                            <img src={text === whiteText ? WhiteSearch : GreySearch} className="white-grey-image-toggle search" alt="" />
                            <input
                                type="text"
                                id="searchBar"
                                placeholder="type here"
                                onClick={() => {
                                    togglePanel({
                                        showMenu: false,
                                        showNoti: false,
                                        showAvatar: false
                                    })
                                }}
                            />
                            {isPink && !showNoti && logo === blackLogo ?
                                <div className="small-triangle show"></div>
                                : null}
                        </>
                    }
                </li>
            </ul>
            {success ? <div className={"avatar-div float-right " + (showAvatar ? "toggle" : "")}>
                {profile ? 
                    <Image {...profile.profileImage} placeholder={fallBackAvatar} alt="avatar" />
                : null}
                <div className="red-overlap"
                    onClick={() => {
                        if (windowWidth >= 1030) {
                            setModal(null)
                            push('/my-profile')
                        } else {
                            toggleAvatar();
                        }
                    }}
                    onMouseOver={() => {
                        setAvatarMenuActive(true)
                    }}
                ></div>
                <AvatarMenu 
                    active={avatarMenuActive}
                    onClick={() => {
                        setAvatarMenuActive(false)
                    }}
                    onMouseEnter={() => {
                        setAvatarMenuActive(true)
                    }}
                    onMouseLeave={() => {
                        setAvatarMenuActive(false)
                    }}
                />
            </div> : null}
        </div>
    )
}

function SubNavItem({
    label,
    to,
    activeOnlyWhenExact,
    counter = 0
}) {
    const match = useRouteMatch({
        path: to,
        exact: activeOnlyWhenExact
    });
    return (
        <li className={`submenu-item ${match ? "selected": ""}`}>
            <Link to={to} className="position-relative">
                <span>{label}</span>
                {counter > 0 ? <span className="itchbook-count pink-text">+{counter}</span> : null}
            </Link>
        </li>
    );
}

export function AvatarMenu({ active, onClick, onMouseLeave }) {
    const { setModal } = useModal()
    const { push } = useHistory()
    const { setSession } = useAuth()
    const queryCache = new QueryCache()

    return (
        <ul id="avatarMenu" 
            onMouseLeave={() => {
                onMouseLeave()
            }}
            className={`nexa-x-bold ${active ? 'active':''}`}>
            <li>
                <Link to="/my-profile">my account</Link>
            </li>
            <SubNavItem
                label="my feed"
                to="/my-profile"
                activeOnlyWhenExact={true}
            />
            <SubNavItem
                label="conversations"
                to="/my-profile/conversations"
            />
            <SubNavItem
                label="itchbook"
                to="/my-profile/itchbook"
            />
            <SubNavItem
                label="gallery"
                to="/my-profile/gallery"
            />
            <SubNavItem
                label="articles"
                to="/my-profile/articles"
            />
            <li>
                <Link to="#" onClick={() => {
                    onClick()
                    setModal({
                        name: 'settings'
                    })
                }}>settings</Link>
            </li>
            <li>
                <Link to="#">
                    <div 
                        onClick={() => {
                            onClick()   
                            queryCache.clear()
                            setSession(null)
                            console.log('clear session')
                            localStorage.clear()
                            push('/')
                        }}
                    >logout</div>
                </Link>
            </li>
        </ul>
    )
}

export function Notification({ show }) {
    const [shownItemCount, setShownItemCount] = useState(15);
    const [items, setItems] = useState(notifications.slice(0, shownItemCount));
    const fetchMoreData = () => {
        setShownItemCount(shownItemCount + 15);
        // a fake async api call that sends 15 more records in 1.5 secs
        setTimeout(() => {
            setItems(notifications.slice(0, shownItemCount + 15))
        }, 1500);
    }
    return (
        <ul id="notificationList" className={show ? 'show' : ''} style={{ maxHeight: 'calc(100vh - 65px)', overflow: "auto" }}>
            <InfiniteScroll
                dataLength={items.length}
                next={fetchMoreData}
                hasMore={true}
                loader={
                    items.length < notifications.length ?
                        <div className="preloader-div text-center"><img src={preloader} alt="preloader" /></div>
                        : null
                }
                scrollableTarget="notificationList"
            >
                {items.map(({ link, src, note, timestamp, artwork }, i) => (
                    <li key={i} className="notification-item">
                        <Link to={link}></Link>
                        <div className="notification-div d-table">
                            <div className="user-profile d-table-cell">
                                <img src={src} alt="user profile" />
                            </div>
                            <div className="notification d-table-cell pn">
                                <div className="note">{parse(note)}</div>
                                <div className="timestamp">{timestamp}</div>
                            </div>
                            {artwork ?
                                <div className="user-artwork d-table-cell">
                                    <img src={artwork} alt="user artwork" />
                                </div>
                                : null}
                        </div>
                    </li>
                ))}
            </InfiniteScroll>
        </ul>
    )
}

export function Tour() {
    const { profile, success } = useGetProfile()
    const tourImages = Object.values(images).filter((img) => img.includes('tour'));
    const tourMobileImages = Object.values(mobileImages).filter((img) => img.includes('tour'));

    let getTourText = (name) => [
        {
            left: 'welcome <br>to itch!',
            leftP: '',
            right: `Hello <span class="pink-text" style="font-family:'ProximaNovaBold'">${name}</span><b>!</b>
            <br><br>
            Before revealing your awesome fashion <b>articles</b> and artworks<br/>
            in your <b>gallery</b>, don’t forget to make an impression with your<br/>
            <b>avatar</b>, <b>billboard</b> & <b>fashion statement</b> for your <span class="pn-bold">itch</span> account.`
        },
        {
            left: 'in transparent fashion',
            leftP: '',
            right: `
            The order of our <b>home</b> page is chronologically determined by your last <b>vote, view, itchbook</b> or <b>comment</b>. The more you interact on our <b>home</b> page, the more you’ll increase your profile visibility.
            `
        },
        {
            left: 'publish your <br>fashion views',
            leftP: '',
            right: `From fashion inspirations, industry experiences<br/>
            to the climate of fashion, you can now<br/>
            share your fashion sentiments on our <b>Zine</b><br/>
            with <b>articles</b>.`,
            right2: `From fashion inspirations,<br/>
            industry experiences to the<br/> 
            climate of fashion, you can now<br/> 
            share your fashion sentiments<br/> 
            on our <b>Zine</b> with <b>articles</b>.`
        },
        {
            left: 'decentralised fashion',
            left2: 'decentralised fashion',
            leftP: `
            Artworks trending with the most <b>votes</b> will be featured next, while active voters are featured for keeping fashion decentralised. Fashion 2.0: In an industry that takes more than giving back, we start by giving creative control back to you.
            `,
            leftP2: `Artworks trending with the most <b>votes</b> will be featured next, while active voters are featured for keeping fashion decentralised. Fashion 2.0: In an industry that takes more than giving back, we start by giving creative control back to you.
            `,
            right: '<a href="/home"><button class="footer-buttons pink-text">Ok, got it!</button></a>'
        },
    ];

    const [closeIcon, setCloseIcon] = useState(greyX);
    const { windowWidth } = useWindowDimensions();

    return (
        <div className="tour-container">
            <Link className="skip-tour" to="/home">Skip tour?</Link>
            <Link to="/home">
                <button
                    id="tourCloseIcon"
                    className="close-icon"
                    onMouseEnter={() => setCloseIcon(pinkX)}
                    onMouseLeave={() => setCloseIcon(greyX)}
                >
                    <img src={closeIcon} alt="close icon" />
                </button>
            </Link>
            {success ? <TourItem 
                tourText={getTourText(getName(profile))} 
                itemImages={windowWidth > 926 ? tourImages : tourMobileImages} 
                windowWidth={windowWidth} /> : null}
        </div>
    )
}

function TourItem({ itemImages, windowWidth, tourText }) {
    const [index, setIndex] = useState(0);
    const [touchY, setTouchY] = useState(0);
    const carouselRef = useRef();

    const handleSelect = (selectedIndex, e) => setIndex(selectedIndex);
    const handleWheel = (swipe) => {
        setTimeout(() => {
            if (swipe) {
                if (index !== 3) {
                    carouselRef.current.next();
                }
            }
            else {
                if (index !== 0) {
                    carouselRef.current.prev();
                }
            }
        }, 250);
    };
    const handleTouch = e => {
        let lastTouch = e.changedTouches[0];
        handleWheel(lastTouch.clientY < touchY);
    };
    const setColumns = (others, col) => {
        return others + (windowWidth > 926 ? col : "row")
    }

    useEffect(() => {
        index === 3 ? document.getElementsByClassName('carousel-control-next')[0].style.display = 'none' : document.getElementsByClassName('carousel-control-next')[0].style.display = 'flex';
        if (windowWidth > 926) {
            index === 0 ? document.getElementsByClassName('carousel-control-prev')[0].style.display = 'none' : document.getElementsByClassName('carousel-control-prev')[0].style.display = 'flex';
        }
        // eslint-disable-next-line
    }, [index])

    return (
        <Carousel
            ref={carouselRef}
            id="tourSlide"
            activeIndex={index}
            onSelect={handleSelect}
            onWheel={(e) => handleWheel(e.deltaY > 0)}
            onTouchStart={(e) => setTouchY(e.touches[0].clientY)}
            onTouchMove={handleTouch}
            interval={null}
            touch={false}
        >
            {itemImages.map((img, i) => (
                <Carousel.Item key={i} id={`tourItem${i}`}>
                    <img
                        className="d-block"
                        src={img}
                        alt={`slide ${i + 1}`}
                    />
                    <div className="tour-caption row">
                        {i === 0 &&
                            <>
                                <div className={setColumns("", "col-5 col-sm-5 col-md-5 col-lg-5")}>
                                    <p className="header pink-text">{parse(tourText[i].left)}</p>
                                </div>
                                <div className={setColumns("right ", "col-7 col-sm-7 col-md-7 col-lg-7")}>
                                    <p id="instructions">{parse(tourText[i].right)}</p>
                                </div>
                            </>
                        }
                        {i === 1 &&
                            <>
                                <div className={setColumns("", "col-6 col-sm-6 col-md-6 col-lg-6")}>
                                    <p className="header pink-text">{parse(tourText[i].left)}</p>
                                </div>
                                <div className={setColumns("right ", "col-6 col-sm-6 col-md-6 col-lg-6")}>
                                    <p id="instructions">{parse(tourText[i].right)}</p>
                                </div>
                            </>
                        }
                        {i === 2 &&
                            <>
                                <div className={setColumns("", "col-6 col-sm-6 col-md-6 col-lg-6")}>
                                    <p className="header pink-text">{parse(tourText[i].left)}</p>
                                </div>
                                <div className={setColumns("right ", "col-6 col-sm-6 col-md-6 col-lg-6")}>
                                    <p id="instructions">{parse(windowWidth > 926 ? tourText[i].right : tourText[i].right2)}</p>
                                </div>
                            </>
                        }
                        {i === 3 &&
                            <>
                                <div className={setColumns("", "col-8 col-sm-8 col-md-8 col-lg-8")}>
                                    <p className="header pink-text">{parse(windowWidth > 926 ? tourText[i].left : tourText[i].left2)}</p>
                                    {windowWidth > 926 ? <p id="instructions">{parse(tourText[i].leftP)}</p> : null}
                                </div>
                                {windowWidth <= 926 ?
                                    <div className="right row">
                                        <p id="instructions">{parse(tourText[i].leftP2)}</p>
                                    </div>
                                    : null}
                                <div className={setColumns("right ", "col-4 col-sm-4 col-md-4 col-lg-4")}>
                                    {parse(tourText[i].right)}
                                </div>
                            </>
                        }
                    </div>
                </Carousel.Item>
            ))}
        </Carousel>
    )
}

export function SuccessModal({ modalClass, greyText, redirect, contactusModal }) {
    const [showModal, toggleModal] = useReducer(
        showModal => !showModal,
        true
    );

    return (
        <Modal
            id="successModal"
            backdropClassName={contactusModal ? "fa-modal-backdrop contact-us" : ("fa-modal-backdrop " + modalClass)}
            dialogClassName="fa-modal-dialog"
            contentClassName={"fa-modal-content " + modalClass}
            show={showModal}
            onHide={toggleModal}
        >
            <Modal.Header>
                {contactusModal ? parse(contactusModal.img) : <img src={Logo} alt="Logo" />}
            </Modal.Header>
            <Modal.Body>
                <p className="pink-text">{contactusModal ? contactusModal.text1 : "Wow, you've done it!"}</p>
                <p className="grey-text first">{contactusModal ? contactusModal.text2 : parse(greyText)}</p>
            </Modal.Body>
            <Modal.Footer className="footer-buttons-div">
                <Link to={contactusModal ? contactusModal.redirect : redirect}>
                    <button className="footer-buttons pink-text ok" onClick={toggleModal}>Ok!</button>
                </Link>
            </Modal.Footer>
        </Modal>
    );
}